import { render, staticRenderFns } from "./PermissionMatrix.vue?vue&type=template&id=6b239571&scoped=true"
import script from "./PermissionMatrix.vue?vue&type=script&lang=js"
export * from "./PermissionMatrix.vue?vue&type=script&lang=js"
import style0 from "./PermissionMatrix.vue?vue&type=style&index=0&id=6b239571&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b239571",
  null
  
)

export default component.exports